import { render, staticRenderFns } from "./goals.vue?vue&type=template&id=115f3108&scoped=true&"
import script from "./goals.vue?vue&type=script&lang=js&"
export * from "./goals.vue?vue&type=script&lang=js&"
import style0 from "./goals.vue?vue&type=style&index=0&id=115f3108&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "115f3108",
  null
  
)

export default component.exports